import { render, staticRenderFns } from "./VehicleBrandsForm.vue?vue&type=template&id=1f011647"
import script from "./VehicleBrandsForm.vue?vue&type=script&lang=js"
export * from "./VehicleBrandsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports